import { useState } from "react";
import Modal from "../ui/Modal";
import Button from "../ui/Button";
import { logout } from "../../services/authService";
import { LogOut } from "lucide-react";

const LogoutConfirmModal = ({ isOpen, onClose }) => {
  const [loggingOut, setLoggingOut] = useState(false);

  const handleConfirmLogout = async () => {
    try {
      setLoggingOut(true);
      await logout();
      window.location.href = "/";
    } catch (err) {
      console.error("Logout error:", err);
      window.location.href = "/";
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={loggingOut ? undefined : onClose} title="Confirm Logout">
      <div style={{ display: "flex", flexDirection: "column", gap: "16px", padding: "4px 0" }}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: "14px" }}>
          <div
            style={{
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              backgroundColor: "rgba(239, 68, 68, 0.12)",
              color: "#dc2626",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <LogOut size={22} />
          </div>
          <div>
            <h4
              style={{
                margin: "0 0 6px 0",
                fontSize: "15px",
                fontWeight: "600",
                color: "var(--text-color, #111827)",
              }}
            >
              Are you sure you want to log out?
            </h4>
            <p
              style={{
                margin: 0,
                fontSize: "13px",
                lineHeight: "1.5",
                color: "var(--text-muted, #4b5563)",
              }}
            >
              You will be signed out of your current session and redirected to the login page.
            </p>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "12px",
            paddingTop: "12px",
            borderTop: "1px solid var(--border-color, #e5e7eb)",
          }}
        >
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={loggingOut}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="danger"
            onClick={handleConfirmLogout}
            loading={loggingOut}
          >
            Yes, Log Out
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LogoutConfirmModal;
